<template>
  <div class="cell-container">
    <ul :class="containerClassName">
      <li
        v-for="(cell, index) in cellList"
        ref="playerCell"
        :key="index"
        :class="{ 'autoplay-on': activeIndex === index }"
      >
        <InstantPlayCell
          :key="`${index}__${cell?.title_list[0]?.text}`"
          :cell="cell"
          :thumbnail-info="thumbnailInfo"
          @on-click-thumbnail="onSelectCell"
          @on-click-icon="onClickIcon"
        />
      </li>
    </ul>
  </div>
</template>
<script setup>
  // CellInstantPlay.vue 리팩토링 컴포넌트
  import { ref, onMounted, defineProps, onBeforeUnmount } from 'vue'
  import { filter } from 'lodash'
  import { getEventListByType } from '@/common/util/event.util'
  import { cellHelper } from '@/common/util/cell/cell-helper'
  import { useRouterComposable } from '@/common/use/useRouterComposable'
  import InstantPlayCell from '@/components/section/template/cell/cell-catalog/InstantPlayCell.vue'
  import { PATH_NAME_PLAYER } from '@/common/router.const'

  const props = defineProps({
    cellList: {
      type: Array,
      default: null,
    },
    thumbnailInfo: {
      type: Object,
      default: null,
    },
    containerClassName: {
      type: String,
      default: '',
    },
  })

  const { onSelectCell } = cellHelper()
  const { pushRouter } = useRouterComposable()

  const playerCell = ref(null)
  const activeIndex = ref(0)

  /**
   * 본편 보기 이동
   * @param cell
   */
  const onClickIcon = (cell) => {
    const { onZzimEvent } = getEventListByType(cell?.event_list ?? [])
    const type =
      onZzimEvent?.bodyjson?.contenttype || onZzimEvent?.bodyjson?.type
    const contentId = cell?.contentid ?? ''
    const isVodType = type === 'program' || type === 'vod'

    pushRouter({
      name: PATH_NAME_PLAYER,
      params: {
        section: isVodType ? 'vod' : 'live',
      },
      query: isVodType ? { contentid: contentId } : { movieid: contentId },
    })
  }

  /**
   * 스크롤 이벤트 - 화면 중앙 opacity 1
   */
  const scrollEvent = () => {
    const imgElList = playerCell.value
    const imgElListLength = imgElList.length
    const isScrollBottom =
      window.innerHeight + window.scrollY >= document.body.offsetHeight

    const filteredElList = filter(imgElList, (imgEl) => {
      const rect = imgEl?.getBoundingClientRect()
      if (
        rect.top * -1 + 56 <=
        imgEl?.scrollHeight - (imgEl?.clientHeight * 90) / 100
      ) {
        return imgEl
      }
    })

    if (isScrollBottom) {
      activeIndex.value = props.cellList.length - 1
      return
    }

    activeIndex.value = imgElListLength - filteredElList.length
  }

  onMounted(() => window.addEventListener('scroll', scrollEvent))
  onBeforeUnmount(() => window.removeEventListener('scroll', scrollEvent))
</script>
<style scoped>
  .cell-container {
    padding-bottom: 2vh;
  }
</style>
